export const SIGNUP_CPF_FIELDS_FLAG_KEY = 'signup_cpf_fields_layout'

// Ladder design: each arm adds one factor on top of the previous one, so every
// neighbouring contrast isolates a single change (chip -> helper text -> order).
export const SIGNUP_CPF_FIELDS_VARIANTS = [
  'control',
  'a_no_email_chip',
  'b_helper_text',
  'c_dob_first',
] as const

export type SignupCpfFieldsVariant = (typeof SIGNUP_CPF_FIELDS_VARIANTS)[number]

export function isSignupCpfFieldsVariant(value: unknown): value is SignupCpfFieldsVariant {
  return (
    typeof value === 'string' && (SIGNUP_CPF_FIELDS_VARIANTS as readonly string[]).includes(value)
  )
}

export const SIGNUP_CPF_FIELDS_FLAGS = {
  [SIGNUP_CPF_FIELDS_FLAG_KEY]: 'control' as SignupCpfFieldsVariant,
}

export type SignupCpfFieldsFlags = typeof SIGNUP_CPF_FIELDS_FLAGS
